import { ValidationRule } from '../../../../components/CustomFormsComponents/hooks/useValidation';

export const INTERVIEWED_FIELDS: {
    name: string;
    labelKey: string;
    maxLength: number;
    validations: ValidationRule[];
}[] = [
    {
        name: 'nombreEntrevistado',
        labelKey: 'execution.interviewed.name',
        maxLength: 150,
        validations: [{ name: 'required' }, { name: 'maxLength', param: 150 }]
    },
    {
        name: 'dniEntrevistado',
        labelKey: 'execution.interviewed.dni',
        maxLength: 8,
        validations: [{ name: 'required' }, { name: 'maxLength', param: 8 }]
    },
    {
        name: 'caracterEntrevistado',
        labelKey: 'execution.interviewed.role',
        maxLength: 100,
        validations: [{ name: 'required' }, { name: 'maxLength', param: 100 }]
    },
    {
        name: 'telefonoEntrevistado',
        labelKey: 'execution.interviewed.phone',
        maxLength: 15,
        validations: [{ name: 'required' }, { name: 'phoneNumber', param: 8 }]
    },
    {
        name: 'emailEntrevistado',
        labelKey: 'execution.interviewed.email',
        maxLength: 150,
        validations: [{ name: 'required' }, { name: 'email' }, { name: 'maxLength', param: 150 }]
    }
];
